import _ from 'lodash';
import { connect } from 'react-redux';
import { search } from '../../modules/logistics/supplier';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => {

	/** @namespace state.lists.supplierIds **/
	/** @namespace state.maps.supplier **/
	/** @namespace state.maps.user **/
	/** @namespace state.maps.supplier **/
	let suppliers = [];

	if (state.lists.supplierIds) {
		suppliers = _.map(state.lists.supplierIds, id => state.maps.supplier[id]);
	}
	return {
		suppliers,
		authUser : state.auth.authUser,
		quickbooksVendorMap : state.maps.quickbooksVendor,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchSuppliers : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);